import axios from 'axios';
import Config from '../../misc/Config';

const API_URL = Config.GFU_API_URL + '/offer-types';

const state = {
    types: [],
    type: null,
};
const getters = {
    offerTypes: (state) => state.types,
    offerType: (state) => state.type,
};
const actions = {
    /**
     * @todo remove see /views/delme.OfferCreateDebug
     */
    async fetchOfferTypes({ commit }, search) {
        const response = await axios.get(API_URL);
        commit('setOfferTypes', response.data.items);
    },
    async fetchOfferType({ commit }, id) {
        const response = await axios.get(API_URL + '/' + id);
        commit('setOfferType', response.data);
    }
};
const mutations = {
    setOfferTypes: (state, types) => state.types = types,
    setOfferType: (state, type) => state.type = type,
};

export default {
    state,
    getters,
    actions,
    mutations,
};